import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import ReactLoading from 'react-loading';
import { toastr } from 'react-redux-toastr';
import { getPlanosControlador } from './generateControladorReportActions';
import { generateControladorReport } from './generateControladorReport';

const S = {
  overlay: {
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
    border: 'none',
  },
  header: {
    background: '#3c8dbc',
    padding: '20px 24px 16px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    borderBottom: 'none',
  },
  headerIcon: {
    width: '40px',
    height: '40px',
    borderRadius: '10px',
    background: 'rgba(255,255,255,0.15)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '14px',
    flexShrink: 0,
  },
  headerTitle: {
    color: '#ffffff',
    fontWeight: '700',
    fontSize: '17px',
    margin: '0 0 6px',
  },
  headerMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    alignItems: 'center',
  },
  badge: {
    background: 'rgba(255,255,255,0.2)',
    color: '#fff',
    padding: '2px 10px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '0.3px',
  },
  metaChip: {
    color: 'rgba(255,255,255,0.85)',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
  closeBtn: {
    background: 'rgba(255,255,255,0.15)',
    border: 'none',
    color: '#fff',
    borderRadius: '8px',
    width: '32px',
    height: '32px',
    cursor: 'pointer',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginLeft: '12px',
  },
  body: {
    padding: '20px 24px',
    background: '#f8fafc',
    minHeight: '200px',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '14px',
    padding: '10px 14px',
    background: '#ffffff',
    borderRadius: '10px',
    border: '1px solid #e2e8f0',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  },
  selectAllLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    fontWeight: '600',
    color: '#374151',
    cursor: 'pointer',
    userSelect: 'none',
    margin: 0,
  },
  countBadge: {
    fontSize: '12px',
    color: '#6b7280',
    background: '#f1f5f9',
    padding: '3px 10px',
    borderRadius: '20px',
    fontWeight: '500',
  },
  tableWrapper: {
    borderRadius: '10px',
    overflow: 'hidden',
    border: '1px solid #e2e8f0',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    background: '#ffffff',
  },
  th: {
    background: '#f1f5f9',
    padding: '10px 12px',
    fontSize: '11px',
    fontWeight: '700',
    color: '#64748b',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: '2px solid #e2e8f0',
    textAlign: 'left',
  },
  td: {
    padding: '10px 12px',
    fontSize: '13px',
    color: '#374151',
    borderBottom: '1px solid #f1f5f9',
  },
  footer: {
    padding: '14px 24px',
    background: '#ffffff',
    borderTop: '1px solid #e2e8f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  cancelBtn: {
    background: '#f1f5f9',
    border: '1px solid #e2e8f0',
    color: '#475569',
    padding: '9px 20px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  printBtn: {
    background: '#3c8dbc',
    border: 'none',
    color: '#ffffff',
    padding: '9px 22px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    boxShadow: '0 2px 8px rgba(37,99,235,0.3)',
  },
  printBtnDisabled: {
    background: '#e2e8f0',
    border: 'none',
    color: '#94a3b8',
    padding: '9px 22px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'not-allowed',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 24px',
    color: '#94a3b8',
    fontSize: '14px',
    gap: '8px',
  },
};

class ControladorReportModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      generating: false,
      allPlanos: [],
      selectedAneis: new Set(),
    };
    this.checkboxAllRef = React.createRef();
  }

  componentDidMount() {
    this.fetchPlanos();
  }

  componentDidUpdate() {
    const aneisLista = this.getAneisOrdenados();
    const { selectedAneis } = this.state;
    const el = this.checkboxAllRef.current;
    if (el) {
      const some = selectedAneis.size > 0 && selectedAneis.size < aneisLista.length;
      el.indeterminate = some;
    }
  }

  getAneisOrdenados() {
    const { allPlanos } = this.state;
    return [...new Set(allPlanos.map(p => p.anel))].sort((a, b) => a - b);
  }

  descricaoAnel(anel) {
    return `Anel ${anel}`;
  }

  async fetchPlanos() {
    const { controlador } = this.props;
    try {
      const result = await getPlanosControlador(controlador.numero_controlador, controlador.grupo_fisico_id);
      const all = result.data || [];
      const aneisIniciais = [...new Set(all.map(p => p.anel))].sort((a, b) => a - b);

      this.setState({
        allPlanos: all,
        selectedAneis: new Set(aneisIniciais),
        loading: false,
      });
    } catch (e) {
      toastr.error('Erro', 'Não foi possível carregar os planos do controlador.');
      this.setState({ loading: false });
    }
  }

  toggleAll = () => {
    const aneisLista = this.getAneisOrdenados();
    const { selectedAneis } = this.state;
    if (selectedAneis.size === aneisLista.length) {
      this.setState({ selectedAneis: new Set() });
    } else {
      this.setState({ selectedAneis: new Set(aneisLista) });
    }
  };

  toggleAnel = anel => {
    const newSet = new Set(this.state.selectedAneis);
    if (newSet.has(anel)) {
      newSet.delete(anel);
    } else {
      newSet.add(anel);
    }
    this.setState({ selectedAneis: newSet });
  };

  handlePrint = async () => {
    const { controlador, onClose } = this.props;
    const { selectedAneis, allPlanos } = this.state;

    if (selectedAneis.size === 0) {
      toastr.warning('Atenção', 'Selecione pelo menos um anel para imprimir.');
      return;
    }

    this.setState({ generating: true });
    try {
      const html = await generateControladorReport(controlador, [...selectedAneis].sort((a, b) => a - b), allPlanos);
      const janela = window.open('', '', 'width=900,height=700');
      janela.document.open();
      janela.document.write(html);
      janela.document.close();
      janela.print();
      janela.close();
      onClose();
    } catch (e) {
      toastr.error('Erro', e.message || 'Não foi possível gerar o relatório.');
    } finally {
      this.setState({ generating: false });
    }
  };

  render() {
    const { controlador, onClose } = this.props;
    const { loading, generating, selectedAneis } = this.state;
    const aneisLista = this.getAneisOrdenados();
    const allSelected = aneisLista.length > 0 && selectedAneis.size === aneisLista.length;
    const isDisabled = generating || selectedAneis.size === 0;

    return (
      <Modal show bsSize="large" onHide={onClose} backdrop="static">
        <div style={S.overlay}>
          <div style={S.header}>
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <div style={S.headerIcon}>
                <i className="fa fa-print" style={{ color: '#fff', fontSize: '17px' }} />
              </div>
              <div>
                <h4 style={S.headerTitle}>Selecionar anéis para impressão</h4>
                <div style={S.headerMeta}>
                  <span style={S.badge}>Controlador {controlador.numero_controlador}</span>
                  {controlador.ip && (
                    <span style={S.metaChip}>
                      <i className="fa fa-server" />
                      {controlador.ip}:{controlador.porta}
                    </span>
                  )}
                  {controlador.endereco && (
                    <span style={S.metaChip}>
                      <i className="fa fa-map-marker" />
                      {controlador.endereco}
                      {controlador.cruzamento ? ` — ${controlador.cruzamento}` : ''}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <button style={S.closeBtn} onClick={onClose} title="Fechar" type="button">
              ✕
            </button>
          </div>

          <div style={S.body}>
            {loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '48px 0' }}>
                <ReactLoading type="bars" color="#2563eb" height={48} width={48} />
              </div>
            ) : aneisLista.length === 0 ? (
              <div style={S.emptyState}>
                <i className="fa fa-exclamation-circle" style={{ fontSize: '36px' }} />
                <p style={{ margin: 0 }}>Nenhum plano cadastrado para este controlador.</p>
              </div>
            ) : (
              <>
                <div style={S.toolbar}>
                  <label style={S.selectAllLabel}>
                    <input
                      ref={this.checkboxAllRef}
                      type="checkbox"
                      checked={allSelected}
                      onChange={this.toggleAll}
                      style={{ width: '15px', height: '15px', cursor: 'pointer' }}
                    />
                    Selecionar todos os anéis
                  </label>
                  <span style={S.countBadge}>
                    {selectedAneis.size} de {aneisLista.length}{' '}
                    {aneisLista.length === 1 ? 'anel selecionado' : 'anéis selecionados'}
                  </span>
                </div>

                <div style={S.tableWrapper}>
                  <table style={S.table}>
                    <thead>
                      <tr>
                        <th style={{ ...S.th, width: '48px', textAlign: 'center' }} />
                        <th style={S.th}>Descrição</th>
                      </tr>
                    </thead>
                    <tbody>
                      {aneisLista.map((anel, idx) => {
                        const isSelected = selectedAneis.has(anel);
                        const rowBg = isSelected ? '#eff6ff' : idx % 2 === 0 ? '#ffffff' : '#f8fafc';
                        return (
                          <tr
                            key={anel}
                            onClick={() => this.toggleAnel(anel)}
                            style={{
                              background: rowBg,
                              borderLeft: isSelected ? '3px solid rgb(60, 141, 188)' : '3px solid transparent',
                              cursor: 'pointer',
                              transition: 'background 0.1s',
                            }}
                          >
                            <td style={{ ...S.td, textAlign: 'center', padding: '10px' }}>
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => this.toggleAnel(anel)}
                                onClick={e => e.stopPropagation()}
                                style={{ width: '15px', height: '15px', cursor: 'pointer' }}
                              />
                            </td>
                            <td style={S.td}>{this.descricaoAnel(anel)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>

          <div style={S.footer}>
            <button style={S.cancelBtn} onClick={onClose} disabled={generating} type="button">
              Cancelar
            </button>
            <button
              style={isDisabled ? S.printBtnDisabled : S.printBtn}
              onClick={this.handlePrint}
              disabled={isDisabled}
              type="button"
            >
              {generating ? (
                <>
                  <i className="fa fa-spinner fa-spin" />
                  Gerando relatório...
                </>
              ) : (
                <>
                  <i className="fa fa-print" />
                  Imprimir
                  {selectedAneis.size > 0 ? ` (${selectedAneis.size} anel${selectedAneis.size !== 1 ? 'is' : ''})` : ''}
                </>
              )}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ControladorReportModal;
